import PlagResult from "../customTypes/PlagiarismData";

const runUpload: Function = async (files: Array<Array<File>>):Promise<Array<PlagResult>>  => {

    const data: FormData = new FormData()

    let i: number=1;
    for (const file of files) {
        data.append(`submission${i}`, file[0], file[0].name);
        i++
    }
    return await (await fetch('https://plagewatch.herokuapp.com/api/plagiarism', {
        method: 'POST',
        body: data
    }).then((response) => response.json()).catch((error) => error));
}

export default runUpload;